var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeverMiss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48.401 48.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37001",
    "data-name": "Path 37001",
    d: "M37.139,24.195A12.945,12.945,0,1,0,24.195,37.139,12.949,12.949,0,0,0,37.139,24.195Zm-3.377,0a9.568,9.568,0,1,1-9.568-9.568A9.571,9.571,0,0,1,33.762,24.195Z",
    transform: "translate(12.512 12.512)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37002",
    "data-name": "Path 37002",
    d: "M49.651,22.448V11.192A8.442,8.442,0,0,0,41.209,2.75H9.692A8.442,8.442,0,0,0,1.25,11.192v28.14a8.442,8.442,0,0,0,8.442,8.442H24.325a1.688,1.688,0,1,0,0-3.377H9.692a5.064,5.064,0,0,1-5.065-5.065V11.192A5.064,5.064,0,0,1,9.692,6.127H41.209a5.064,5.064,0,0,1,5.065,5.065V22.448a1.688,1.688,0,1,0,3.377,0Z",
    transform: "translate(0 1.877)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37003",
    "data-name": "Path 37003",
    d: "M15.75,2.938v7.879a1.688,1.688,0,1,0,3.377,0V2.938a1.688,1.688,0,1,0-3.377,0Z",
    transform: "translate(18.143)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37004",
    "data-name": "Path 37004",
    d: "M6.75,2.938v7.879a1.688,1.688,0,0,0,3.377,0V2.938a1.688,1.688,0,0,0-3.377,0Z",
    transform: "translate(6.882)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37005",
    "data-name": "Path 37005",
    d: "M47.963,7.25H2.938a1.688,1.688,0,1,0,0,3.377H47.963a1.688,1.688,0,1,0,0-3.377Z",
    transform: "translate(0 7.507)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37006",
    "data-name": "Path 37006",
    d: "M16.25,15.688v5.628a1.69,1.69,0,0,0,.934,1.511l3.377,1.688a1.688,1.688,0,1,0,1.508-3.021l-2.443-1.222V15.688a1.688,1.688,0,1,0-3.377,0Z",
    transform: "translate(18.768 15.953)",
    fill: "#ff0185",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeverMiss);
export default __webpack_public_path__ + "static/media/mever-miss.a3c66eedb438816d2247f521e689a3c0.svg";
export { ForwardRef as ReactComponent };